import React from 'react'
import RegistrationForm from './components/RegistrationForm'
import './App.css'

const brands: Record<string, { className: string; favicon: string }> = {
  paru: {
    className: 'app-paru',
    favicon: '/favicon-paru.ico',
  },
  jb: {
    className: 'app-jb',
    favicon: '/favicon-jb.ico',
  },
  //casa saenz is default
}

function App() {
  const app = process.env.REACT_APP_NAME?.toLowerCase()
  console.log('REACT_APP_NAME', app)
  const brand = app && brands[app] ? brands[app] : null
  const appClass = brand ? brand.className : ''

  React.useEffect(() => {
    if (brand) {
      document.body.classList.add(brand.className)
      const link = document.querySelector(
        "link[rel*='icon']",
      ) as HTMLLinkElement
      if (link) {
        link.href = brand.favicon
      }
    } else {
      const link = document.querySelector(
        "link[rel*='icon']",
      ) as HTMLLinkElement
      if (link) {
        link.href = '/favicon.ico'
      }
    }
  }, [brand])

  return (
    <div className={`App ${appClass}`}>
      <RegistrationForm />
    </div>
  )
}

export default App
